import EmptyRouterView from './../views/functionary/EmptyRouterView.vue'
import Administrator from './../views/functionary/Home.vue'

import DocumentHome from './../views/functionary/document/Document.vue'
import DirectoryHome from './../views/functionary/directory/Directory.vue'
import CellarHome from "./../views/functionary/cellar/Cellar.vue"
import TrashDocument from "../views/functionary/TrashDocument/TrashDocument.vue"

export const routes = [
  {
    path: '/funcionario',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'functionaryHome',
        component: Administrator,
      },
      {
        path: 'documentos/:id',
        name: 'documentsFunctionary',
        component: DocumentHome,
        props: true,
        meta: {
          breadcrumb: [
            { name: 'documentos' }
          ]
        }
      },
      {
        path: 'bodegas',
        name: 'cellarsFunctionary',
        component: CellarHome,
      }, 
      {
        path: 'directorio/:id',
        name: 'directoryFunctionary',
        component: DirectoryHome,
        props: true,
        meta: {
          breadcrumb: [
            { name: 'directorio' }
          ]
        }
      },
      {
        path: 'eliminados',
        name: 'trashFunctionary',
        component: TrashDocument,
        meta: {
          breadcrumb: [
            { name: 'eliminados' }
          ]
        }
      },

    ]
  },
]